<div class="sent-team home-section">
  <div class="title-section">
      <div class="inbox-marker"></div>
      <div class="div-label">
          <mat-label class="label-title">Enviados</mat-label>
          <a class="change-inbox" (click)="showSentPersonal()">
            Cambiar a mi Bandeja
          </a>
       </div>
  </div>
  <div class="search-section">
    <mat-form-field class="search-well-card dense-3">
        <mat-label class = "label-well">Buscá un pozo</mat-label>
          <input type="text" aria-label="Well" matInput #searchText (keyup.enter)="getHandoversHomeSentTeamWithFilter(searchText.value)">
          <span matSuffix class="cursor-pointer" (click)="getHandoversHomeSentTeamWithFilter(searchText.value)">
            <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
          </span>
      </mat-form-field> 
  </div>  
  <div class="content-section">
      <div class="handovers" *ngIf="totalHandoversSentTeam != 0">
          <app-handover-card *ngFor="let handover of handoversSentTeam" [handover]="handover" [destinationLabel]="destinationLabel"></app-handover-card>
      </div>
      <div class="empty-content" *ngIf="totalHandoversSentTeam == 0">
          <div *ngIf="this.textSearch == ''">
              <p class="sent-team-empty">No hay Handovers aún</p>
              <p class="sent-team-empty-text">Cuando un miembro de tu equipo envie un Handover <br> Podrás visualizarlo acá</p>
          </div>
          <div *ngIf="this.textSearch != ''">
              <p class="sent-team-empty">No hay handovers para el filtro aplicado</p>
          </div>
      </div>
  </div>
</div>
